export default __webpack_public_path__ + "static/media/roth_401k_light.647d23ad.png";